import React from 'react';

import NavigationMenuItem from '../NavigationMenuItem/NavigationMenuItem';

import Apps24 from 'icons/Apps24';
import Group24Filled from 'icons/Group24Filled';
import LocalMall24Filled from 'icons/LocalMall24Filled';
import Settings24Filled from 'icons/Settings24Filled';

import { useAuth } from 'utils/auth';
import { hasRoutePermission } from 'utils/routePermissions';

import styles from './navigation-menu.scss';
import { useTranslation } from 'react-i18next';

/**
 * Apps Navigation menu.
 * You can specify items inside.
 *
 * @example
 * <NavigationMenu />
 */
export default function NavigationMenu() {
    const auth = useAuth();
    const { t } = useTranslation();

    return (
        <nav className={styles.wrapper}>
            <NavigationMenuItem label={t('place.products')} icon={<LocalMall24Filled />} to={'/pages'} />
            <NavigationMenuItem label={t('place.clients')} icon={<Group24Filled />} to={'/clients'} />
            {hasRoutePermission('apps', auth.getRole()) && <NavigationMenuItem label={t('place.apps')} icon={<Apps24 />} to={'/apps'} />}
            {hasRoutePermission('settings', auth.getRole()) && <NavigationMenuItem label={t('place.settings')} icon={<Settings24Filled />} to={'/settings'} />}
        </nav>
    );
};
